import { render, staticRenderFns } from "./ExEquipmentDetail.vue?vue&type=template&id=55fa0047&scoped=true&"
import script from "./ExEquipmentDetail.vue?vue&type=script&lang=js&"
export * from "./ExEquipmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExEquipmentDetail.vue?vue&type=style&index=0&id=55fa0047&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fa0047",
  null
  
)

export default component.exports